export default "__VITE_ASSET__DaDNVPdY__"